var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.systemCreating || _vm.userCreating)?_c('div',{staticClass:"message-row",class:{ system: _vm.systemCreating, user: _vm.userCreating }},[_c('div',{staticClass:"author"},[(_vm.systemCreating)?_c('img',{attrs:{"src":require("@/assets/cb-logo.png"),"height":"50px"}}):_vm._e()]),_c('div',{staticClass:"spinner"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }